import config from '@config';
import { FEATURE_FLAGS } from '@root/constants';
import { Platform } from 'react-native';

type FeatureFlagState = {
  show?: boolean;
};

const getConfiguredBannerAdUnitId = (): string => {
  if (Platform.OS !== 'android') return '';
  return config.AD_MOB_BANNER_ID_ANDROID || '';
};

const isFeatureEnabled = (adMobFeatureFlag?: FeatureFlagState | boolean): boolean => {
  if (typeof adMobFeatureFlag === 'boolean') return adMobFeatureFlag;
  if (typeof adMobFeatureFlag?.show === 'boolean') return adMobFeatureFlag.show;
  return false;
};

export const AD_MOB_FEATURE_FLAG = FEATURE_FLAGS.AD_MOB_ENABLED;

export const isAdMobGloballyEnabled = (): boolean => Platform.OS === 'android';

export const isAdMobFeatureEnabled = (adMobFeatureFlag?: FeatureFlagState | boolean): boolean => {
  if (!isAdMobGloballyEnabled()) return false;
  return isFeatureEnabled(adMobFeatureFlag);
};

export const getBannerAdUnitId = (): string | null => {
  if (!isAdMobGloballyEnabled()) return null;
  const adUnitId = getConfiguredBannerAdUnitId();
  return adUnitId || null;
};

export const isAdsEnabled = (adMobFeatureFlag?: FeatureFlagState | boolean): boolean => {
  if (!isAdMobFeatureEnabled(adMobFeatureFlag)) return false;
  return !!getBannerAdUnitId();
};
